import React from 'react';
import { Container, Col, Row } from '../../components/grid';
import {
  Paragraph, Heading1, Heading2, LinkStyled, Bold,
} from '../../components/typography';
import { ItemTraverser } from '../../containers/commerce';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import RowProductView from '../../components/grid/RowProductView';
import ProductView1 from '../../components/commerce/ProductViews/ProductView1';

export default () => (
  <SidemenuLayout menuPicker="Kildevand" activeSidemenu="SanPellegrinoVand">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>San Pellegrino</Heading1>
          <Heading2>Naturligt mineralvand</Heading2>
          <Paragraph>
            San Pellegrinos vand er af højeste kvalitet, nemlig det der kaldes naturligt mineralvand, hvilket er af bedre kvalitet end almindeligt kildevand. <LinkStyled to="/kildevand#Vand-Klacificering">Læs mere her.</LinkStyled>
          </Paragraph>
          <Paragraph>
            Både San Pellegrino med brus og Acqua Panna uden brus er begge kvalificeret som naturligt mineralvand.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>San Pellegrino: Mineralvand med brus</Heading2>
          <Paragraph>
            Sidder du på en italiensk restaurent og siger: ”uno acqua frizzante, per favore”, så får du højst sandsynligt en San Pellegrino (læs: ”en danskvand, tak”).
            Pellegrino fabrikken er blevet verdenskendt på deres gode, friske og kvalitetsbevidste Pellegrino vand med brus.
            Politikens magasin Tjek giver den 5 ud af 6 stjerner og kalder bl.a. vanden for &quot;God til mad&quot;, &quot;Frisk i munden&quot; og mild og neutral.
            (<LinkStyled external to="http://politiken.dk/forbrugogliv/livsstil/art5398990/San-Pellegrino" title="Se artikel om San Pellegrino">Politiken.dk</LinkStyled>).
          </Paragraph>
          <Paragraph>
            Se vores store sortiment af <LinkStyled to="/kildevand" title="Kildevand">kildevand</LinkStyled>.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="kildevandSanPellegrino" display={ProductView1} />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Acqua Panna: Mineralvand uden brus</Heading2>
          <Paragraph>
            Acqua Panna er San Pellegrinos vand uden brus.
            Denne vand er som sagt naturligt mineralvand og er derfor en vand af højeste kvalitet.
            Acqua Panna er en vand, der er beskrevet som ”perfekt balanceret i dets mineraler, let som en fjer, behagende blød og fløjlsagtig”.
            Vi fører Acqua Panna i 100cl og 25cl.
          </Paragraph>
          <Paragraph>
            Indhold i mg/l: Hydrogecarbonat (HCO3-) 103, Calcium (Ca2+) 32, Sulfat (SO4 2-) 22, Chlorid(CL-) 8,5, Silizium (SiO2) 7, Natrium (Na+) 6,4, Magnesium (Mg2+) 6,2, Nitrat (NO3-) 2,9, Kalium (K+) 0,8
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="kildevandAcquaPanna" display={ProductView1} />
      </RowProductView>
    </Container>
    <Container white>
      <Row>
        <Col xs={12}>
          <Paragraph fontSize="30px" fontWeight="bold" padding="40px 20px 0 20px">
            FAKTA!
          </Paragraph>
          <Paragraph fontSize="16px" padding="20px 20px 40px 20px">
            San Pellegrino området var allerede utroligt kendt i middelalderlen.
            I 1500-tallet var kilden blevet så kendt at <Bold>Leonardo Da Vinci</Bold> tegnede kilden op på et kort han lavede over Brembo floden, der på den tid havde været kendt for helbredende kræfter i over to århundrede.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
